import { MessageProcessor } from '../websocketProcessorTypes'
import store from '../../redux/store'
import {
  addNotification,
  setInitialNotifications,
  setUnreadCount,
} from '@/redux/slices/notificationSlice'
import { NotificationDisplayType } from '@/redux/types/notifications'
import { toast } from 'sonner'
import { downloadGameExportAPI } from '@/api/room'
import { triggerBlobDownload } from '@/lib/utils'

export const notificationProcessors: MessageProcessor[] = [
  {
    type: 'initial_notifications',
    handler: (data) => {
      store.dispatch(
        setInitialNotifications({
          notifications: data.notifications,
          unreadCount: data.unread_count,
          hasMore: data.has_more,
          totalCount: data.total_count,
          currentPage: data.current_page,
        })
      )
    },
  },

  {
    type: 'notification',
    handler: (data) => {
      const shouldIncrementUnread =
        data.notification.display_type === NotificationDisplayType.BELL_ICON

      store.dispatch(
        addNotification({
          notification: data.notification,
          shouldIncrementUnread,
        })
      )
    },
  },
  {
    type: 'unread_count',
    handler: (data) => {
      store.dispatch(setUnreadCount(data.count))
    },
  },
  {
    type: 'room_duplication_complete',
    handler: (data) => {
      if (!data || !data.data) {
        console.error('Invalid room duplication complete data:', data)
        return
      }

      const { success, processed_count, total_chatbots, errors } = data.data

      if (total_chatbots === 0) {
        // No chatbots to process, just show success
        toast.success('Room duplicated successfully!', { duration: 5000 })
        return
      }

      if (success) {
        toast.success(
          `Room duplication complete! Documents processed: ${processed_count}/${total_chatbots}`,
          { duration: 5000 }
        )
      } else {
        toast.warning(
          `Room duplication complete. Documents processed: ${processed_count}/${total_chatbots}. Some errors occurred.`,
          { duration: 8000 }
        )
        if (errors && errors.length > 0) {
          console.error('Document processing errors:', errors)
        }
      }
    },
  },
  {
    type: 'game_export_complete',
    handler: (data) => {
      if (!data?.data) return
      const { export_token, room_id, file_size, export_type } = data.data
      const sizeKB = file_size ? Math.round(file_size / 1024) : null
      const sizeLabel = sizeKB ? ` (${sizeKB} KB)` : ''
      toast.success(`Export ready${sizeLabel}. Downloading…`, { duration: 4000 })

      const fileNameMap: Record<string, string> = {
        game: `exported-room-details-${room_id}.json`,
        all_advisors: `exported-room-all-advisor-details-${room_id}.json`,
        advisor: `exported-room-advisor-details-${room_id}.json`,
      }
      const fileName = fileNameMap[export_type] ?? `exported-room-details-${room_id}.json`

      downloadGameExportAPI(room_id, export_token)
        .then((blob) => triggerBlobDownload(blob, fileName))
        .catch(() => toast.error('Download failed. Please try again.'))
    },
  },
  {
    type: 'game_export_failed',
    handler: (data) => {
      const error = data?.data?.error || 'Unknown error'
      toast.error(`Export failed: ${error}`, { duration: 8000 })
    },
  },
]
